const types = {
  AGREEMENT: 'christmasDays',
  FREE: 'ownDays',
  CHRISTMAS: 'christmasDays',
  LASTYEAR:'lastYear'
};

class HolidaySummaryController {
  constructor() {
  }

  $onInit() {
    this.titleKey = this.getTitleKey(this.watchingEmployee);
  }

  hasDays(prop) {
    return this[prop] !== null && this[prop] !== undefined && this[prop] > -1;
  }

  noInfo() {
    return !this.hasDays(types.AGREEMENT) && !this.hasDays(types.FREE) && !this.hasDays(types.CHRISTMAS) && !this.hasDays(types.CHRISTMAS);
  }

  getTitleKey(watchingEmployee) {
    return watchingEmployee ? 'VACATIONS_ABSENCES.HOLIDAY_SUMMARY.DAYS_AVAILABLE_EMPLOYEE' : 'VACATIONS_ABSENCES.HOLIDAY_SUMMARY.DAYS_AVAILABLE';
  }
}

export default HolidaySummaryController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/holidaySummary/holidaySummary.controller.js